<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="table-responsive">
    <b-table
      striped
      hover
      fixed
      head-variant="dark"
      show-empty
      responsive
      :busy="loading"
      :fields="fields"
      :items="canRead(access) ? data : []"
      style="border-radius: 10px; overflow: scroll; max-height: 500px;"
    >
      <template v-slot:table-busy="">
        <div class="text-center text-danger my-2">
          <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
        </div>
      </template>
      <template v-slot:cell(prmsOperations)="data">
        {{formatOperationsString(data.value)}}
      </template>
      <template v-slot:cell(prmsCreatedTime)="data">
        {{dateWithDDMMYYYYFormat(data.value)}}
      </template>
      <template v-slot:cell(action)="data">
        <div class="text-center">
          <permission-edit
            :access="'master_permission'"
            :permission="data.item"
            @onDeleteClicked="onActionDelete"
            @onViewClicked="onActionView"
            @onEditClicked="onActionEdit"/>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="onPaginationChanged"
    ></b-pagination>
  </div>
</template>

<script>
import { formatDateTime } from '@/util/date';
import PermissionEdit from './Edit';

export default {
  name: 'PermissionList',
  components: { PermissionEdit },
  props: ['access', 'data', 'group', 'loading', 'pagination'],
  data() {
    return {
      fields: [
        {
          key: 'prmsName',
          label: 'Permission Name',
          class: 'text-left',
        },
        {
          key: 'prmsOperations',
          label: 'Operations',
          class: 'text-center',
        },
        {
          key: 'prmsCreatedTime',
          label: 'Created',
          class: 'text-center',
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
        },
      ],
    };
  },
  methods: {
    formatOperationsString(operations) {
      if (Array.isArray(JSON.parse(operations))) {
        return JSON.parse(operations).join(', ');
      }
      return operations;
    },
    dateWithDDMMYYYYFormat(v) {
      return formatDateTime(v, 'DD MMMM YYYY HH:mm:ss');
    },
    onPaginationChanged(page) {
      this.$emit('onPageChanged', page);
    },
    onActionDelete(data) {
      this.$emit('onActionDelete', data);
    },
    onActionEdit(data) {
      this.$emit('onActionEdit', data);
    },
    onActionView(data) {
      this.$emit('onActionView', data);
    },
  },
};
</script>

<style scoped>

</style>
